import './checkout_contact.css';
import { useEffect, useState } from "react";
import { UserIcon } from "../../assets/icons/UserIcon";
import { useCheckout } from "../../context/CheckoutContext";
import { CheckoutFormStep } from "../CheckoutFormStep/CheckoutFormStep";
import { useSearchParams } from "react-router-dom";

export const CheckoutContact = () => {
    //HOOKS
    const {
        setCheckoutStep,
        name,
        setName,
        lastname,
        setLastname,
        phone,
        setPhone,
        email,
        setEmail,
    } = useCheckout();
    const [searchParams, setSearchParams] = useSearchParams();

    //STATES
    const [nameError, setNameError] = useState("");
    const [lastnameError, setLastnameError] = useState("");
    const [phoneError, setPhoneError] = useState("");
    const [emailError, setEmailError] = useState("");

    //FUNCTIONS
    const continueStep = () => {
        let error = false;

        if (name === "") {
            error = true;
            setNameError("Required");
        }

        if (lastname === "") {
            error = true;
            setLastnameError("Required");
        }

        if (phone === "") {
            error = true;
            setPhoneError("Required");
        }

        if (email === "") {
            error = true;
            setEmailError("Required");
        }

        if (!error) {
            setCheckoutStep(2);
        }
    }

    //EFFECTS
    useEffect(() => {
        if (searchParams.get("testing_mode") !== null) {
            setName("testing");
            setLastname("order");
            setPhone("0000000000");
            setEmail("andres33mauricio@gmail.com");
        }
    }, []);

    return (
        <CheckoutFormStep
            step={1}
            title={"Contact Information"}
            icon={<UserIcon />}
            id={"checkout_contact"}
        >
            <div className='checkout_input_group'>
                <div className='checkout_input_container'>
                    <label>
                        Name
                    </label>
                    <input type='text' value={name} onChange={(e) => {setName(e.target.value); setNameError("")}} />
                    <span>
                        {nameError}
                    </span>
                </div>
                <div className='checkout_input_container'>
                    <label>
                        Lastname
                    </label>
                    <input type='text' value={lastname} onChange={(e) => {setLastname(e.target.value); setLastnameError("")}} />
                    <span>
                        {lastnameError}
                    </span>
                </div>
            </div>
            <div className='checkout_input_group'>
                <div className='checkout_input_container'>
                    <label>
                        Phone
                    </label>
                    <input type='text' value={phone} onChange={(e) => {setPhone(e.target.value); setPhoneError("")}} />
                    <span>
                        {phoneError}
                    </span>
                </div>
                <div className='checkout_input_container'>
                    <label>
                        Email
                    </label>
                    <input type='text' value={email} onChange={(e) => {setEmail(e.target.value); setEmailError("")}} />
                    <span>
                        {emailError}
                    </span>
                </div>
            </div>

            <div className='checkout_delivery_continue_container'>
                <button onClick={continueStep}>
                    Continue
                </button>
            </div>
        </CheckoutFormStep>
    );
}